import React from 'react';

import PropTypes from 'prop-types';

import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Breadcrumbs } from '../../../../shared/components/Breadcrumbs';
import { FilterButton } from '../../../../shared/components/Filter';
import { SearchBar } from '../../../../shared/components/SearchBar';
import { FILTERS } from '../../constants';
import { useFilters } from '../../hooks';
import ViewToggle from './ViewToggle';

const Header = ({ onSearchChange, searchInput }) => {
  const { activeFilters, clearFilters } = useFilters();

  return (
    <div className="flex items-center justify-between p-2 border-b">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="-mr-1.5" />
        <Separator className="data-[orientation=vertical]:h-4" orientation="vertical" />
        <Breadcrumbs />
      </div>

      <div className="flex items-center gap-2">
        <ViewToggle />

        <FilterButton
          activeFilters={activeFilters}
          clearFilters={clearFilters}
          filters={FILTERS}
        />

        <SearchBar className="h-[30px]" onChange={onSearchChange} value={searchInput} />
      </div>
    </div>
  );
};

Header.propTypes = {
  onSearchChange: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
};

export default Header;
